/**
 * ArtifactGraphLink — Phase 3 slot (GH-258).
 *
 * This component is intentionally a no-op placeholder. Phase 3 will replace
 * the body with a real knowledge graph link/embed. The import path and prop
 * interface are locked so Phase 3 can fill this in without touching the drawer.
 *
 * DO NOT add business logic here in Phase 1.
 */

import { useTranslation } from 'react-i18next'
import { Share2 } from 'lucide-react'
import { cn } from '../../lib/utils'

interface Props {
  /** Upload/artifact ID — Phase 3 will use this to query the KG */
  artifactId: string
  isDark: boolean
}

/** Slot reserved for Phase 3 (GH-258) — renders a labelled placeholder banner. */
export function ArtifactGraphLink({ artifactId: _artifactId, isDark }: Props) {
  const { t } = useTranslation('artifact')

  return (
    <section aria-label={t('graphLink.title')} className="space-y-3">
      <h3 className={cn('text-xs font-semibold uppercase tracking-wide', isDark ? 'text-neutral-400' : 'text-neutral-500')}>
        {t('graphLink.title')}
      </h3>

      {/* Phase 3 will replace this div with the actual graph embed */}
      <div
        className={cn(
          'flex items-center gap-2 rounded-lg border border-dashed px-3 py-4 text-xs',
          isDark ? 'border-white/[0.08] text-neutral-600' : 'border-neutral-300 text-neutral-400',
        )}
        data-testid="artifact-graph-link-placeholder"
      >
        <Share2 className="h-3.5 w-3.5 shrink-0" />
        <span>{t('graphLink.placeholder')}</span>
      </div>
    </section>
  )
}
